import {swalSuccess} from "../swalHelper";

/**
 * An updated version of handleAjaxSuccess that simply
 * returns the promise and response after calling Swal and
 * the popup is dismissed
 */
export function handleAjaxSuccessNoRedirect(response) {
	// noinspection JSUnresolvedVariable
	return swalSuccess(response.data.message)
		.then(() => response);
}
